// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalCGA-background{
    position: fixed;
    top: 0;
    left: 0;
    align-self: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center; 
}

    .modalCGA-content {
        position: relative;
        width: 40%;
        height: 60%;
        background-color: var(--white-base);
        display: flex;
        flex-direction: column;
        border-radius: 20px;
        padding: 0px 20px;
        overflow-y: auto;
    }

        .modalCGA-content-close-btn{
            width: 30px;
            height: 30px;
            cursor: pointer;
            margin-top: 2%;
            margin-left: 94%;
        }
        .modalCGA-content-close-btn:hover {
            transform: scale(1.07); 
            transition: transform 0.3s ease;
        }

        .modalCGA-content-container{
          display: flex;
          flex-direction: row;
        }
          .modalCGA-content-container-left{
            width: 50%;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .modalCGA-content-container-right{
            width: 40%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: end;
            gap: 10px;
          }
            .modalCGA-content-text-titel {
                font-family: Inter;
                margin-top: 1%;
                margin-bottom: 1%;

                /* TEXT FONT */
                font-family: Inter;
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 16px; /* 100% */
                letter-spacing: -0.144px;
            }
            .modalCGA-content-input-titel {
                border: solid 1px var(--gray-20);
                border-radius: 5px;
                width: 80%;
                height: 40px;
                outline: none;
                padding-left: 1%;
                padding-right: 1%;
                border-radius: 15px;

                font-family: Inter;
            }
            .modalCGA-content-input-date {
              border: solid 1px var(--gray-20);
              border-radius: 2px;
              width: 40%;
              height: 40px;
              outline: none;
              padding-left: 1%;
              padding-right: 1%;
              border-radius: 15px;
              cursor: pointer;

              font-family: Inter;
            }
        .modalCGA-content-text-mitglieder {
            font-family: Inter;
            margin-top: 5%;
            margin-bottom: 1%;
            height: 40px;

            /* TEXT FONT */
            font-family: Inter;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px; /* 100% */
            letter-spacing: -0.144px;
        }
          .modalCGA-content-names {
            width: 90%;
            height: 90%;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
            overflow-y: auto;
            margin-right: auto;
            margin-left: auto;
        
            /* TEXT FONT */
            font-family: Inter;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
          }



/*USER PROFILES*/
.modalCGA-content-names-border {
  position: relative;
  border-radius: 20px;
  height: fit-content;
  border: 1px solid var(--border);
  background: var(--white-base);
  cursor: pointer;

  min-width: calc(50% - 2%); /* Two items in a row, considering the gap */
  margin-bottom: 5px; /* Adjust the margin to reduce the vertical gap */
  box-sizing: border-box; /* Include border and padding in the width calculation */
}

  
  .modalCGA-content-names-selected{
    background: var(--border);
    border: 1px solid var(--gray-50);
    cursor: pointer;
  }  

  .modalCGA-content-names-inner-container{
    margin: 15px;
  }
  
  .modalCGA-content-names-profile{
    display: flex;
    gap: 8%;
  }

  .modalCGA-content-names-profile-image {
    width: 50px; /* Adjust as needed */
    height: 50px; /* Adjust as needed */
    border-radius: 50%; /* Circle image */
  }
  
  .modalCGA-content-names-header{
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 20px;
  }

  .modalCGA-content-names-profile-name {
    -webkit-user-select: none;
            user-select: none;
    width: fit-content;
    font-weight: bold;
    white-space: nowrap;
  }
  
  .modalCGA-content-names-profile-role {
    -webkit-user-select: none;
            user-select: none;
    color: var(--vzk-blue); /* Adjust color as needed */
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 16px; /* 200% */
  }
  
  .modalCGA-content-names-choice-button{
    align-self: right;
    margin-left: auto;
  }
  
  .modalCGA-content-names-body{
    min-width: 100%;
  }

  .modalCGA-content-names-profile-choice-button{
    width: fit-content;
    height: fit-content;
    margin-right: 0px;
    margin-left: auto;
  }

  .modalCGA-content-create {
    position: relative;
    align-self: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 10px;
    padding: 0px 20px;
    width: fit-content;
    min-height: 40px;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--blue-50);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    font-family: Inter;
    color: var(--white-base);
    font-weight: 700;
    line-height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modalCGA-content-create:hover {
    transform: scale(1.03); 
    transition: transform 0.3s ease;
  }`, "",{"version":3,"sources":["webpack://./src/widgets/ModalCreateGruppenassessment.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;IAEI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;;QAEI;YACI,WAAW;YACX,YAAY;YACZ,eAAe;YACf,cAAc;YACd,gBAAgB;QACpB;QACA;YACI,sBAAsB;YACtB,+BAA+B;QACnC;;QAEA;UACE,aAAa;UACb,mBAAmB;QACrB;UACE;YACE,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,SAAS;UACX;UACA;YACE,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,gBAAgB;YAChB,SAAS;UACX;YACE;gBACI,kBAAkB;gBAClB,cAAc;gBACd,iBAAiB;;gBAEjB,cAAc;gBACd,kBAAkB;gBAClB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB,EAAE,SAAS;gBAC5B,wBAAwB;YAC5B;YACA;gBACI,gCAAgC;gBAChC,kBAAkB;gBAClB,UAAU;gBACV,YAAY;gBACZ,aAAa;gBACb,gBAAgB;gBAChB,iBAAiB;gBACjB,mBAAmB;;gBAEnB,kBAAkB;YACtB;YACA;cACE,gCAAgC;cAChC,kBAAkB;cAClB,UAAU;cACV,YAAY;cACZ,aAAa;cACb,gBAAgB;cAChB,iBAAiB;cACjB,mBAAmB;cACnB,eAAe;;cAEf,kBAAkB;YACpB;QACJ;YACI,kBAAkB;YAClB,cAAc;YACd,iBAAiB;YACjB,YAAY;;YAEZ,cAAc;YACd,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB,EAAE,SAAS;YAC5B,wBAAwB;QAC5B;UACE;YACE,UAAU;YACV,WAAW;YACX,eAAe;YACf,uBAAuB;YACvB,SAAS;YACT,gBAAgB;YAChB,kBAAkB;YAClB,iBAAiB;;YAEjB,cAAc;YACd,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;UACnB;;;;AAIV,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;;EAEf,yBAAyB,EAAE,4CAA4C;EACvE,kBAAkB,EAAE,iDAAiD;EACrE,sBAAsB,EAAE,wDAAwD;AAClF;;;EAGE;IACE,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,OAAO;EACT;;EAEA;IACE,WAAW,EAAE,qBAAqB;IAClC,YAAY,EAAE,qBAAqB;IACnC,kBAAkB,EAAE,iBAAiB;EACvC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB,EAAE,2BAA2B;IACnD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;;IAExC,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,+BAA+B;EACjC","sourcesContent":[".modalCGA-background{\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 999;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center; \r\n}\r\n\r\n    .modalCGA-content {\r\n        position: relative;\r\n        width: 40%;\r\n        height: 60%;\r\n        background-color: var(--white-base);\r\n        display: flex;\r\n        flex-direction: column;\r\n        border-radius: 20px;\r\n        padding: 0px 20px;\r\n        overflow-y: auto;\r\n    }\r\n\r\n        .modalCGA-content-close-btn{\r\n            width: 30px;\r\n            height: 30px;\r\n            cursor: pointer;\r\n            margin-top: 2%;\r\n            margin-left: 94%;\r\n        }\r\n        .modalCGA-content-close-btn:hover {\r\n            transform: scale(1.07); \r\n            transition: transform 0.3s ease;\r\n        }\r\n\r\n        .modalCGA-content-container{\r\n          display: flex;\r\n          flex-direction: row;\r\n        }\r\n          .modalCGA-content-container-left{\r\n            width: 50%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 10px;\r\n          }\r\n          .modalCGA-content-container-right{\r\n            width: 40%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            align-items: end;\r\n            gap: 10px;\r\n          }\r\n            .modalCGA-content-text-titel {\r\n                font-family: Inter;\r\n                margin-top: 1%;\r\n                margin-bottom: 1%;\r\n\r\n                /* TEXT FONT */\r\n                font-family: Inter;\r\n                font-size: 20px;\r\n                font-style: normal;\r\n                font-weight: 700;\r\n                line-height: 16px; /* 100% */\r\n                letter-spacing: -0.144px;\r\n            }\r\n            .modalCGA-content-input-titel {\r\n                border: solid 1px var(--gray-20);\r\n                border-radius: 5px;\r\n                width: 80%;\r\n                height: 40px;\r\n                outline: none;\r\n                padding-left: 1%;\r\n                padding-right: 1%;\r\n                border-radius: 15px;\r\n\r\n                font-family: Inter;\r\n            }\r\n            .modalCGA-content-input-date {\r\n              border: solid 1px var(--gray-20);\r\n              border-radius: 2px;\r\n              width: 40%;\r\n              height: 40px;\r\n              outline: none;\r\n              padding-left: 1%;\r\n              padding-right: 1%;\r\n              border-radius: 15px;\r\n              cursor: pointer;\r\n\r\n              font-family: Inter;\r\n            }\r\n        .modalCGA-content-text-mitglieder {\r\n            font-family: Inter;\r\n            margin-top: 5%;\r\n            margin-bottom: 1%;\r\n            height: 40px;\r\n\r\n            /* TEXT FONT */\r\n            font-family: Inter;\r\n            font-size: 20px;\r\n            font-style: normal;\r\n            font-weight: 700;\r\n            line-height: 16px; /* 100% */\r\n            letter-spacing: -0.144px;\r\n        }\r\n          .modalCGA-content-names {\r\n            width: 90%;\r\n            height: 90%;\r\n            flex-wrap: wrap;\r\n            justify-content: center;\r\n            gap: 10px;\r\n            overflow-y: auto;\r\n            margin-right: auto;\r\n            margin-left: auto;\r\n        \r\n            /* TEXT FONT */\r\n            font-family: Inter;\r\n            font-size: 18px;\r\n            font-style: normal;\r\n            font-weight: 600;\r\n            line-height: 32px;\r\n          }\r\n\r\n\r\n\r\n/*USER PROFILES*/\r\n.modalCGA-content-names-border {\r\n  position: relative;\r\n  border-radius: 20px;\r\n  height: fit-content;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  cursor: pointer;\r\n\r\n  min-width: calc(50% - 2%); /* Two items in a row, considering the gap */\r\n  margin-bottom: 5px; /* Adjust the margin to reduce the vertical gap */\r\n  box-sizing: border-box; /* Include border and padding in the width calculation */\r\n}\r\n\r\n  \r\n  .modalCGA-content-names-selected{\r\n    background: var(--border);\r\n    border: 1px solid var(--gray-50);\r\n    cursor: pointer;\r\n  }  \r\n\r\n  .modalCGA-content-names-inner-container{\r\n    margin: 15px;\r\n  }\r\n  \r\n  .modalCGA-content-names-profile{\r\n    display: flex;\r\n    gap: 8%;\r\n  }\r\n\r\n  .modalCGA-content-names-profile-image {\r\n    width: 50px; /* Adjust as needed */\r\n    height: 50px; /* Adjust as needed */\r\n    border-radius: 50%; /* Circle image */\r\n  }\r\n  \r\n  .modalCGA-content-names-header{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .modalCGA-content-names-profile-name {\r\n    user-select: none;\r\n    width: fit-content;\r\n    font-weight: bold;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .modalCGA-content-names-profile-role {\r\n    user-select: none;\r\n    color: var(--vzk-blue); /* Adjust color as needed */\r\n    font-size: 12px;\r\n    font-style: normal;\r\n    font-weight: 800;\r\n    line-height: 16px; /* 200% */\r\n  }\r\n  \r\n  .modalCGA-content-names-choice-button{\r\n    align-self: right;\r\n    margin-left: auto;\r\n  }\r\n  \r\n  .modalCGA-content-names-body{\r\n    min-width: 100%;\r\n  }\r\n\r\n  .modalCGA-content-names-profile-choice-button{\r\n    width: fit-content;\r\n    height: fit-content;\r\n    margin-right: 0px;\r\n    margin-left: auto;\r\n  }\r\n\r\n  .modalCGA-content-create {\r\n    position: relative;\r\n    align-self: center;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n    margin-top: 10px;\r\n    padding: 0px 20px;\r\n    width: fit-content;\r\n    min-height: 40px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    background-color: var(--blue-50);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n\r\n    font-family: Inter;\r\n    color: var(--white-base);\r\n    font-weight: 700;\r\n    line-height: 36px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .modalCGA-content-create:hover {\r\n    transform: scale(1.03); \r\n    transition: transform 0.3s ease;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
